import React, { useEffect } from "react";
import { Button } from "theme-ui";
import { Decimal } from "@liquity/lib-base";
import { useLiquity } from "../../../hooks/LiquityContext";
import { Transaction, useMyTransactionState } from "../../Transaction";
import { useTroveView } from "../context/TroveViewContext";
import { useCollateralValidationState } from "./useCollateralValidationState";

type ApproveProps = {
  amount: Decimal;
};

const transactionId = "trove-approve";

export const Approve: React.FC<ApproveProps> = ({ amount }) => {
  const { dispatchEvent } = useTroveView();
  const { liquity: { send: liquity } } = useLiquity();
console.log("Checking approval state for ",amount.toString()) // JJ 
  const { hasApproved } = useCollateralValidationState(amount);
  const transactionState = useMyTransactionState(transactionId);

//  useEffect(() => {
//    if (transactionState.type === "confirmedOneShot") {
//      dispatchEvent("STAKE_APPROVED");
//    }
//  }, [transactionState.type, dispatchEvent]);

  if (hasApproved) {
    console.log("HAS ENOUGH COLLATERAL APPROVED")
    return null;
  }

  console.log("NEED TO APPROVE MORE COLLATERAL from ",liquity) // JJ

  return (    
    <Transaction
      id={transactionId}
      send={liquity.approveCollateralTokens.bind(liquity, undefined)}
      showFailure="asTooltip"
      tooltipPlacement="bottom"
    >
      <Button sx={{ width: "60%" }}>Approve</Button>
    </Transaction>
  );
};
